import { render, staticRenderFns } from "./proDetail.vue?vue&type=template&id=17566a24&scoped=true&"
import script from "./proDetail.vue?vue&type=script&lang=js&"
export * from "./proDetail.vue?vue&type=script&lang=js&"
import style0 from "./proDetail.vue?vue&type=style&index=0&id=17566a24&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17566a24",
  null
  
)

export default component.exports